// BOOST AI
(function () {
  // ---- CONFIG ----
  var ROOT_ID = 'boost-sd__filter-tree-wrapper';
  var TITLE_SELECTOR = '.boost-sd__filter-option-title';
  var LABEL_SELECTOR = '.boost-sd__filter-option-item-label';

  // Translate only when UI is NOT Polish
  if (window.__IS_PL_LANGUAGE__) {
    return;
  }

  // ---- DICTIONARY ----
  var T = {
    // Section headers
    'Zainteresowania': 'Interests',
    'Styl graficzny': 'Graphic style',
    'Kolorystyka': 'Color scheme',
    'Rozmiar': 'Size',
    'Produkt': 'Product',

    // Option values
    'anime': 'anime',
    'natura': 'nature',
    'średniowieczne fantasy': 'medieval fantasy',
    'zabawne': 'funny',
    'Lochy': 'Dungeons',
    'minimalistyczne': 'minimalist',
    'retro': 'retro',
    'pixelart': 'pixel art',
    'abstrakcja': 'abstract',
    'ilustracja': 'illustration',
    '3D': '3D',
    'Produkt': 'Product',
    'Podkładki pod mysz': 'Mouse pads',
    'militarne': 'military',
    'motoryzacja': 'automotive',
    'scifi': 'sci-fi',
    'art': 'art',
    'Bluzy': 'Hoodies',
    'T-shirty': 'T-shirts',
    'Workoplecaki': 'Drawstring bags'
  };

  var LOG_MISSING = true;
  var missing = Object.create(null);

  // Build a case-insensitive regex that matches any dictionary key as a whole word
  function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  var KEY_RE = new RegExp('\\b(' + Object.keys(T).map(esc).join('|') + ')\\b', 'gi');

  function splitLabelAndCount(text) {
    var m = String(text || '').trim().match(/^(.+?)(\s*\(\d+\))?$/);
    return m ? { label: m[1].trim(), count: m[2] || '' } : { label: text, count: '' };
  }

  function lookup(src) {
    if (!src) return null;
    var direct = T[src];
    if (direct) return direct;
    var lower = src.toLowerCase();
    for (var k in T) if (k.toLowerCase() === lower) return T[k];
    return null;
  }

  // Replace only the first text node of an element (preserving icons, children)
  function setFirstTextNode(el, text) {
    var tn = null;
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3) { tn = n; break; }
    }
    if (tn) tn.nodeValue = text;
    else el.insertBefore(document.createTextNode(text), el.firstChild);
  }

  function currentLangKey() {
    // NIE zmieniamy sposobu detekcji języka – opieramy się wyłącznie na __IS_PL_LANGUAGE__
    return window.__IS_PL_LANGUAGE__ ? 'pl' : 'en';
  }

  function translateVisible(el) {
    if (!el) return;

    // Guard live: jeśli przełączyłeś na PL bez pełnego reloadu, nic nie tłumaczymy
    if (window.__IS_PL_LANGUAGE__) {
      // ale zostawmy ślad w logach, żeby było jasne
      if (el === document.querySelector(TITLE_SELECTOR) || el === document.querySelector(LABEL_SELECTOR)) {
        // ograniczenie hałasu w konsoli
      }
      return;
    }

    var LANG_KEY = currentLangKey();

    // jeśli element był cache'owany dla innego języka – wyczyść cache na nim
    if (el.dataset && el.dataset.boostTranslatedLang && el.dataset.boostTranslatedLang !== LANG_KEY) {
      delete el.dataset.boostTranslated;
      delete el.dataset.boostTranslatedLang;
    }

    var raw = (el.textContent || '').trim();
    if (!raw) return;

    var parts = splitLabelAndCount(raw);
    var mapped = lookup(parts.label); // istnieje -> mamy tłumaczenie PL->EN

    // ZAWSZE próbujemy tłumaczyć; cache nie blokuje działania
    if (mapped) {
      var finalText = mapped + parts.count;
      if (el.matches && el.matches(TITLE_SELECTOR)) {
        setFirstTextNode(el, finalText);
      } else {
        el.textContent = finalText;
      }
      if (el.dataset) {
        el.dataset.boostTranslated = '1';
        el.dataset.boostTranslatedLang = LANG_KEY;
      }
    } else {
      // brak mapowania – nie blokujemy kolejnych prób; tylko log i zapamiętanie języka
      if (LOG_MISSING && !missing[parts.label]) {
        missing[parts.label] = 1;
      }
      if (el.dataset) {
        el.dataset.boostTranslatedLang = LANG_KEY;
      }
    }
  }

  function translateAria(target) {
    if (!target || !target.getAttribute) return;
    if (window.__IS_PL_LANGUAGE__) return; // guard live
    var v = target.getAttribute('aria-label');
    if (!v) return;
    var translated = v.replace(KEY_RE, function (match) {
      var m = lookup(match);
      return m || match;
    });
    if (translated !== v) {
      target.setAttribute('aria-label', translated);
    }
  }

  function translateIn(root) {
    if (!root || !root.querySelectorAll) return;
    if (window.__IS_PL_LANGUAGE__) {
      // tryb PL – nic nie ruszamy, ale logujemy 1x per wywołanie
      return;
    }
    var nodes = root.querySelectorAll(TITLE_SELECTOR + ',' + LABEL_SELECTOR);
    nodes.forEach(translateVisible);

    // Keep aria-labels consistent so Boost won't re-inject Polish
    root.querySelectorAll(TITLE_SELECTOR + ', .boost-sd__filter-option-item-button').forEach(translateAria);
  }

  var currentRoot = null;
  var mo = null;

  function observe(root) {
    if (!root) return;
    currentRoot = root;

    // disconnect poprzedni obserwator jeśli był
    if (mo) {
      try { mo.disconnect(); } catch(e){}
    }

    translateIn(root); // initial pass

    mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        if (m.type === 'childList') {
          // debug
          if ((m.addedNodes && m.addedNodes.length) || (m.removedNodes && m.removedNodes.length)) {
          }
          m.addedNodes && m.addedNodes.forEach(function (n) {
            if (n.nodeType === 1) translateIn(n);
          });
        } else if (m.type === 'characterData') {
          var host = m.target.parentElement || m.target;
          translateVisible(host);
        } else if (m.type === 'attributes' && m.attributeName === 'aria-label') {
          translateAria(m.target);
          if (m.target.matches(TITLE_SELECTOR + ',' + LABEL_SELECTOR)) translateVisible(m.target);
        }
      }
    });

    mo.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-label']
    });
  }

  // Watchdog: jeśli Boost/Motion podmieni cały wrapper, podpinamy obserwator ponownie
  var rebindMo = null;
  function startRebindWatchdog() {
    if (rebindMo) return;
    rebindMo = new MutationObserver(function () {
      var r = document.getElementById(ROOT_ID);
      if (r && r !== currentRoot) {
        observe(r);
      }
    });
    try {
      rebindMo.observe(document.body || document.documentElement, { childList: true, subtree: true });
    } catch (e) {
    }
  }

  function init() {
    startRebindWatchdog();

    var root = document.getElementById(ROOT_ID);
    if (root) {
      observe(root);
    } else {
      var tries = 40;
      var timer = setInterval(function () {
        var r = document.getElementById(ROOT_ID);
        if (r || --tries <= 0) {
          clearInterval(timer);
          if (r) {
            observe(r);
          } else {
          }
        }
      }, 250);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
